// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React from 'react'
import { Redirect, Switch, withRouter } from 'react-router-dom'
import Container from '../../common/container/Container'
import Header from '../header/Header'
import { i18n } from '../index'
import CustomerAmounts from './CustomerAmounts'
// import Loss from './Loss'
import type { OptionType } from '../../common/select/Select'
import CustomerSales from './customerSales/CustomerSales'
import FeelingMeterNotes from './feelingMeterNotes/FeelingMeterNotes'
import Feelings from './feelings/Feelings'
import IncentiveSales from './incentiveSales/IncentiveSales'
import ThumbsUp from './thumbsUp/ThumbsUp'
import TotalSales from './totalSales/TotalSales'
import Wastage from './wastage/Wastage'
//import Usage from './usage/Usage'
import { Typography } from '@mui/material'
import { inject } from 'mobx-react'
import RestrictedRoute from '../auth/RestrictedRoute'
import { AuthStore } from '../auth/types'
import css from './Reporting.css'
const BASE_PATH = '/raportointi'
type ReportingProps = {
  history: Record<string, any>
  location: Record<string, any>
  authStore: AuthStore
}
type State = {
  month: string
}

@inject('authStore')
class Reporting extends React.Component<ReportingProps, State> {
  getTabs = () => {
    const isManager = this.props.authStore.userHasPermission('nav_manager')
    const isAokAdmin = this.props.authStore.userHasPermission('nav_admin')
    const allTabs = [
      isManager && {
        label: i18n.t('reporting.incentiveSales'),
        value: 'aloitteellinen-myynti',
      },
      {
        label: i18n.t('reporting.customerAmounts'),
        value: 'asiakasmaarat',
      },
      {
        label: i18n.t('reporting.totalSales'),
        value: 'kokonaismyynti',
      },
      isManager && {
        label: i18n.t('reporting.feelingsMeter'),
        value: 'fiilismittari',
      },
      isAokAdmin && {
        label: i18n.t('reporting.feelingsMeterFeedbacks'),
        value: 'fiilismittaripalautteet',
      },
      {
        label: i18n.t('reporting.wastage'),
        value: 'havikki',
      },
      isManager && {
        label: i18n.t('reporting.thumbsUp'),
        value: 'peukutettavat',
      }, //{
      //  label: i18n.t('reporting.usage'),
      //  value: 'käyttö',
      //},
    ]
    //Filter out any falsy values
    return allTabs.filter((tab) => !!tab)
  }
  onTabClick = (tab) => {
    const { history } = this.props
    history.push(`${BASE_PATH}/${tab.value}`)
  }
  getActiveTab = () => {
    const { location } = this.props
    const parts = location.pathname.split('/')

    if (parts.length === 3) {
      return parts[2]
    }

    return 'asiakasmaarat'
  }
  monthChanged = (option: OptionType) => {
    this.setState({
      month: option.value,
    })
  }

  render() {
    return (
      <div className={css.component}>
        <Header
          title={i18n.t('reporting.header')}
          tabs={this.getTabs()}
          tabActive={this.getActiveTab()}
          onTabClick={this.onTabClick}
        />
        <Container>
          <Typography variant='h6'>{i18n.t('reporting.header')}</Typography>
          <Switch>
            <RestrictedRoute
              path={`${BASE_PATH}/asiakasmaarat`}
              requiredPermission='nav_basic'
              component={CustomerSales}
            />
            <RestrictedRoute
              path={`${BASE_PATH}/kokonaismyynti`}
              requiredPermission='nav_basic'
              component={TotalSales}
            />
            <RestrictedRoute exact requiredPermission='nav_basic' path={BASE_PATH} component={CustomerAmounts} />
            <RestrictedRoute
              requiredPermission='nav_manager'
              path={`${BASE_PATH}/aloitteellinen-myynti`}
              component={IncentiveSales}
            />
            {/*
            <Route path={`${BASE_PATH}/peukutettavat-palvelut`} component={IncentiveSales} />
            */}
            <RestrictedRoute requiredPermission='nav_basic' path={`${BASE_PATH}/havikki`} component={Wastage} />

            <RestrictedRoute
              requiredPermission='nav_manager'
              path={`${BASE_PATH}/peukutettavat`}
              component={ThumbsUp}
            />
            <RestrictedRoute
              requiredPermission='nav_manager'
              path={`${BASE_PATH}/fiilismittari`}
              component={Feelings}
            />
            <RestrictedRoute
              requiredPermission='nav_admin'
              path={`${BASE_PATH}/fiilismittaripalautteet`}
              component={FeelingMeterNotes}
            />
            {/* <Route
            requiredPermission="nav_basic"
            path={`${BASE_PATH}/käyttö`}
            component={Usage} />*/}
            <Redirect from={`${BASE_PATH}/`} to={BASE_PATH} />
          </Switch>
        </Container>
      </div>
    )
  }
}

export default withRouter(Reporting)
